import React, { useEffect, useRef } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";

const LoadMore = ({ loading, items, hasMore, pagination, infinite }) => {
  const sentinelRef = useRef(null);

  useEffect(() => {
    if (!infinite || !hasMore || loading) {
      return undefined;
    }

    const sentinel = sentinelRef.current;
    if (!sentinel || typeof IntersectionObserver === "undefined") {
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0] && entries[0].isIntersecting) {
          pagination();
        }
      },
      { rootMargin: "240px 0px" }
    );

    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [infinite, hasMore, loading, pagination]);

  return (
    <Row>
      <Col xs={12} className="col-load-more col-text-center">
        {loading && items && (
          <div>
            <Spinner animation="border" size="sm" /> Loading {items.length > 0 ? "more" : ""}...
          </div>
        )}
        {!loading && hasMore && !infinite && (
          <Button onClick={(e) => pagination(e)} variant="outline-light" type="submit">
            Load More
          </Button>
        )}
        {infinite && hasMore && <div ref={sentinelRef} aria-hidden="true" />}
      </Col>
    </Row>
  );
};

export default LoadMore;
